import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <main className="page">
      <section className="home__hero">
        <span className="home__eyebrow fade-up">Product Leader · San Francisco Bay Area</span>
        <h1 className="home__headline fade-up fade-up-delay-1">
          I build AI products <em>people trust</em> at scale.
        </h1>
        <p className="home__body fade-up fade-up-delay-2">
          Ten years at Workday shaping how enterprise AI gets built, adopted, and trusted —
          from defining the product to closing the room. I work at the intersection of
          narrative strategy, product conviction, and commercial outcomes.
        </p>
        <div className="home__cta-group fade-up fade-up-delay-3">
          <Link to="/work" className="btn">See the work</Link>
          <a href="mailto:simoneaehrlich@gmail.com" className="btn btn--ghost">Get in touch</a>
        </div>

        <blockquote className="home__quote-block fade-up fade-up-delay-4">
          <p className="home__quote-text">
            "Simone has a unique combination of design, product, and business acumen
            that sets her apart in any room. Even in the most stressful situations,
            she remains unflappable."
          </p>
          <cite className="home__quote-attr">Erin Sullivan, COO · Toyo (former Workday colleague)</cite>
        </blockquote>
      </section>

      <div className="home__metrics fade-up">
        <div className="home__metric">
          <span className="home__metric-number">13MM</span>
          <p className="home__metric-label">Monthly active users on AI platform (2022–2026)</p>
        </div>
        <div className="home__metric">
          <span className="home__metric-number">97%</span>
          <p className="home__metric-label">CSAT across enterprise accounts</p>
        </div>
        <div className="home__metric">
          <span className="home__metric-number">$8B+</span>
          <p className="home__metric-label">ARR supported through direct customer engagement</p>
        </div>
        <div className="home__metric">
          <span className="home__metric-number">75+</span>
          <p className="home__metric-label">Person multidisciplinary org led across Workday portfolio</p>
        </div>
      </div>

      <div className="contact-strip">
        <div>
          <h2>Let's talk.</h2>
          <p>Currently exploring VP, Head of Product, and Senior Director opportunities where AI is core to the product.</p>
        </div>
        <a href="mailto:simoneaehrlich@gmail.com" className="btn">simoneaehrlich@gmail.com</a>
      </div>
    </main>
  );
}
